import React, { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatPhoneInput } from '@/lib/utils';

interface TelefonoPasoProps {
  telefono: string;
  onTelefonoChange: (telefono: string) => void;
}

const TelefonoPaso: React.FC<TelefonoPasoProps> = ({ telefono, onTelefonoChange }) => {
  const [customerPhone, setCustomerPhone] = useState("");

  useEffect(() => {
    if (telefono && telefono !== customerPhone) {
      setCustomerPhone(telefono);
    }
  }, [telefono]);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneInput(e.target.value);
    if (formatted !== undefined) {
      setCustomerPhone(formatted);
      onTelefonoChange(formatted);
    }
  };

  return (
    <Card className='pb-1'>
      <CardHeader className='pb-1'>
        <CardTitle>Paso 3: ¿Cuál es tu teléfono?</CardTitle>
        <CardDescription>Necesitamos tu número de teléfono para enviarte notificaciones importantes sobre tus alquileres.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-1">
            <Label htmlFor="telefono">Tu número de teléfono</Label>
            <Input
              id="telefono"
              type="tel"
              placeholder="+58... Indica tu número de teléfono. Por ejemplo: +584121234567"
              value={customerPhone}
              onChange={handlePhoneChange}
              required
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TelefonoPaso;
